type AngularRuntimeGlobals = typeof globalThis & {
  ngDevMode?: boolean;
  ngJitMode?: boolean;
};

const runtimeGlobals = globalThis as AngularRuntimeGlobals;
const hostName = runtimeGlobals.location?.hostname ?? '';
const isLocalDevHost = hostName === 'localhost' || hostName === '127.0.0.1';

if (typeof runtimeGlobals.ngDevMode === 'undefined') {
  runtimeGlobals.ngDevMode = isLocalDevHost;
}

if (typeof runtimeGlobals.ngJitMode === 'undefined') {
  runtimeGlobals.ngJitMode = isLocalDevHost;
}
